import React, {useEffect, useState} from "react";
import axios from 'axios';

import Groupbox from "../core/Groupbox";

import { IconButton, Typography, Tooltip, TextField, List, ListItem,
ListItemText } from '@material-ui/core';

import {Add, PersonAdd, PersonAddDisabled, Remove} from '@material-ui/icons';

import {ErrorBar, MessageBar} from "../phish2/Bars";

import { WaiversToolbar } from "./WaiversToolbar";

import AlertDialog from "../phish2/AlertDialog";
import {EvaWaiverDialog} from "./EvaWaiverDialog";

export function Waivers(props){
    const [isAdmin, setIsAdmin] = useState(false);
    const [error, setError] = useState(null);
    const [docxClients,setDocxClients] = useState([]);
    const [clientFilter,setClientFilter] = useState(null);
    const [client,setClient] = useState(null);

    const [showAlertDialog, setShowAlertDialog] = useState(() => () =>
        alert('no show alert dialog docked'));

    const [showEvaWaiverDialog, setShowEvaWaiverDialog] = useState(() => () =>
        alert('no show alert dialog docked'));

    const displayError = error => {
        if (error.response) {
            setError(error.response.status + ' ' + error.response.data);
        } else if(error.message) {
            setError(error.message);
        } else{
            setError(error);
        }
    }

    const filterClients = (clients,filter) => {
        let r = clients;
        if(!r ){
            return r;
        }
        if(filter){
            r = clients.filter(p => (p.title && p.title.toUpperCase().startsWith(filter.toUpperCase())));
        }
        r.sort((a,b) => {
            if(a.title > b.title){
                return 1;
            }
            if(a.title < b.title){
                return -1;
            }
            return 0;
        });

        return r;
    };
    const loadIsAdmin = () => {
        axios.get('api/phish/isAdmin')
            .then(response => {
                setIsAdmin(response.data);
            })
            .catch(() => setIsAdmin(false));
    }
    const loadClients = () => {
        const url = 'api/waivers/docxClients';
        axios.get(url)
            .then(response => setDocxClients(response.data))
            .catch(displayError)
    }
    useEffect(loadIsAdmin, []);
    useEffect(loadClients,[])

    if(!isAdmin){
        return '';
    }

    return <div>
        <ErrorBar error={error} onClear={() => setError(null)}/>
        <WaiversToolbar
        clientFilter={clientFilter}
        onClientFilter={value => setClientFilter(value)}
        isAllowNewEvaWaiver={true}
        newEvaWaiver={() => showEvaWaiverDialog()}
        />
        <div style={{ display: 'flex' }}>
            <div style={{ flex: 1, overflowY: 'scroll', height: '80vh', overflowX: 'auto' }}>
                <List>
                {
                        filterClients(docxClients,clientFilter).map(docxClient =>
                            <ListItem selected={docxClient === client} key={docxClient}
                                        onClick={() => setClient(docxClient)} dense button>
                                        <ListItemText>{docxClient.title + docxClient.id}</ListItemText>
                                    </ListItem>)
                        
                        }    
                </List>
                
            </div>
            <div style={{ flex: 2 ,overflowY: 'scroll', height: '80vh', overflowX: 'auto' }}>
                <Groupbox header='IPs' >
                    
                </Groupbox>
                
                <Groupbox header='Waiver' >
                    
                </Groupbox>
            </div>
    </div>
    <AlertDialog
                onDock={show => setShowAlertDialog(() => show)}/>
                <EvaWaiverDialog onDock={show => setShowEvaWaiverDialog(() => show)}/>
    </div>
}